module.exports = __webpack_public_path__ + "0d25b5a50caaa4aa22b6157731efbfc7.gif";